import { videoRouter } from './courseVideo/router';

import { articleRouter } from './courseArticle/router';

export const courseDetailRouters = [
  // 视频课路由
  ...videoRouter,
  ...articleRouter,
  // ..
].map((router) => {
  router.path = `/web/:tenant${router.path}`;
  return router;
});
